import { GTM_ID } from '@utils/google-tag-manger';
import Script from 'next/script';

// https://vercel.com/docs/projects/environment-variables/framework-environment-variables
const BNBFINDER_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV || 'development';
const gtmQueryParams =
  BNBFINDER_ENV === 'production'
    ? ''
    : '&gtm_auth=NzbYM2ANXKzNmSit-ymoGw&gtm_preview=env-214&gtm_cookies_win=x';

export const GoogleTagManagerNoScript = (): JSX.Element => {
  return (
    // Add this code immediately after the opening <body> element on every page of your website.
    // https://developers.google.com/tag-platform/tag-manager/web
    <noscript>
      <iframe
        src={`https://load.a.savvy.com/ns.html?id=${GTM_ID}${gtmQueryParams}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      ></iframe>
    </noscript>
  );
};

export const GoogleTagManagerScript = (): JSX.Element => {
  return BNBFINDER_ENV === 'development' ? (
    // Load the GTM script from Google's servers, enabling additional debugging options.
    <Script
      id="gtag-base"
      strategy="afterInteractive"
      // @ts-ignore
      fetchpriority="lowest"
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'${gtmQueryParams}';f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`,
      }}
    />
  ) : (
    // Load the GTM script from Stape's servers, using a custom loader to prevent ad blockers from identifying the container.
    <Script
      id="gtag-base"
      strategy="afterInteractive"
      // @ts-ignore
      fetchpriority="lowest"
      //note: Using cutom loader script to prevent ad blockers from identifying the container.
      //      this uses an encryped version of the GTM container id. If the container id changes,
      //      the script will need to be updated. https://app.stape.io/container/fltmbenl/power-up/custom-loader.
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://load.a.savvy.com/e20l2fltmbenl.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','ym=aWQ9R1RNLVBHTVFWTVAy&page=1');`,
      }}
    />
  );
};
